module.exports = __webpack_public_path__ + "static/media/partner-logo12.855bfd56.png";